module.exports = __webpack_public_path__ + "static/media/lobo_kit_items-2x.e14ce507.png";